import { Button } from "@mui/material";
import axios from "axios";
import React, { useEffect, useState } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { baseUrl } from "../../Config/baseUrl";
import { FaRegFilePdf } from "react-icons/fa";

export default function Book() {
  const [data, setData] = useState([]);
  const navigate = useNavigate();

  const getBook = () => {
    axios
      .get(`${baseUrl}/blog/book-api/`, {
        headers: {
          Authorization: `Token ${localStorage.getItem("token")}`,
          "Access-Control-Allow-Origin": "*",
        },
      })
      .then((response) => {
        if (response.data.response_code === 200) {
          setData(response.data?.data || []);
        } else {
          toast.error(response.data.message);
        }
      })
      .catch(() => {
        toast.error("Failed to load books");
      });
  };

  const deleteFAQ = (id) => {
    axios
      .delete(`${baseUrl}/blog/book-api/`, {
        data: { book_id: id },
        headers: {
          Authorization: `Token ${localStorage.getItem("token")}`,
          "Access-Control-Allow-Origin": "*",
        },
      })
      .then((res) => {
        toast.success(res?.data?.message || "Book deleted");
        getBook();
      })
      .catch(() => {
        toast.error("Error deleting book");
      });
  };

  useEffect(() => {
    getBook();
  }, []);

  return (
    <div className="w-full min-h-screen px-4 py-1">
      {/* Header */}
      <p className="my-4 sm:my-0 text-3xl sm:text-4xl lg:text-5xl text-center text-blue-900 underline">
        Book  
      </p>

      {/* Add Button */}
      <div className="flex justify-end mb-2">
        <NavLink to="/book/add">
          <Button variant="outlined">Add</Button>
        </NavLink>
      </div>

      {/* Grid */}
      <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3">
        {data.map((item) => (
          <div
            key={item.id}
            className="flex flex-col h-full p-4 bg-white border border-gray-300 rounded-lg shadow-md"
          >
            {/* Title */}
            <p className="mb-3 text-lg font-semibold text-black break-words">
              {item.title}
            </p>

            {/* Image */}
            {item?.image && (
              <img
                src={item.image}
                alt={item.title}
                className="w-full h-48 object-cover rounded-md mb-4"
              />
            )}

            {/* Buttons */}
            <div className="flex flex-wrap justify-center gap-4 mt-auto">
              {item?.file && (
                <Button
                  className="w-full sm:w-auto"
                  onClick={() => window.open(item?.file)}
                  variant="outlined"
                  color="error"
                >
                  <FaRegFilePdf className="text-red-500" />
                </Button>
              )}
              <Button
                className="w-full sm:w-auto"
                onClick={() => navigate("/book/update", { state: item.id })}
                variant="outlined"
              >
                Update
              </Button>

              <Button
                className="w-full sm:w-auto"
                onClick={() => deleteFAQ(item.id)}
                variant="outlined"
                color="error"
              >
                Delete
              </Button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
